/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ComponentRef, Injectable, Renderer2 } from '@angular/core';
import type { ProcessRowParams } from 'ag-grid-community';

import { gridRowCacheKey } from '../../grid-internal.utils';
import { GRID_EVENT } from '../../grid-public-events';
import { GridFeatureReadyParams } from '../feature.interfaces';
import { AbstractGridSelectBarFeature } from './abstract-grid-select-bar-feature';

import {
  GridRowSelectioniInitParams,
  GridRowSelectionsComponent,
} from './grid-row-selections-component';

interface SelectBarConfig {
  componentRef: ComponentRef<GridRowSelectionsComponent>;
  row: GridRowSelectioniInitParams;
}

@Injectable()
export class GridSelectBarFeature extends AbstractGridSelectBarFeature {
  private selectBars: { [id: string]: Maybe<SelectBarConfig> } = {};

  constructor(protected renderer: Renderer2) {
    super();
  }

  onGridReady(params: GridFeatureReadyParams): void {
    super.onGridReady(params);
  }

  process(params: ProcessRowParams): void {
    if (!params.eRow) {
      return;
    }

    this.createAndAttachComponent(params);

    params.addRenderedRowListener(GRID_EVENT.virtualRowRemoved, () => {
      this.detachAndDestroyComponent(params);
    });
  }

  private createAndAttachComponent(row: GridRowSelectioniInitParams): void {
    const component = this.selectBars[gridRowCacheKey(row.node)];
    if (component) {
      this.detachAndDestroyComponent(row);
    }
    const componentRef = this.createComponent();
    this.attachComponent(row, componentRef);

    this.selectBars[gridRowCacheKey(row.node)] = { row, componentRef };
  }

  private detachAndDestroyComponent(row: GridRowSelectioniInitParams): void {
    this.detachComponent(row);

    const selectBar = this.selectBars[gridRowCacheKey(row.node)];

    if (selectBar) {
      selectBar.componentRef.destroy();
      this.selectBars[gridRowCacheKey(row.node)] = void 0;
    }
  }

}
